module.exports = __webpack_public_path__ + "fonts/tficonfont.4b876117.woff";